"use strict";

exports.__esModule = true;
var _DescriptionElement = require("./DescriptionElement");
Object.keys(_DescriptionElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DescriptionElement[key]) return;
  exports[key] = _DescriptionElement[key];
});
var _DescriptionThumbnail = require("./DescriptionThumbnail");
Object.keys(_DescriptionThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DescriptionThumbnail[key]) return;
  exports[key] = _DescriptionThumbnail[key];
});
var _DescriptionFields = require("./DescriptionFields");
Object.keys(_DescriptionFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DescriptionFields[key]) return;
  exports[key] = _DescriptionFields[key];
});
var _DescriptionHeader = require("./DescriptionHeader");
Object.keys(_DescriptionHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DescriptionHeader[key]) return;
  exports[key] = _DescriptionHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});